<template>
  <div class="hello">

    <b-container>
        <b-row style="margin-top:40px">
            <b-col>
                <h2>Sales Report</h2>
                <hr>
            </b-col>
        </b-row>


        <!-- Custom Date -->
        <b-row >
            <b-col>
                <div  style="width:400px; color:green">
                    <b-form-group
                        id="fieldset-19"
                        label="Start Date"
                        label-for="input-date1"
                        >
                        <b-form-datepicker @input="dateChanged" value-as-date id="example-datepicker1" :max="maxDate" v-model="customDateStart" class="mb-2"></b-form-datepicker>
                    </b-form-group>
                </div>
            </b-col>
            <b-col>
                <div  style="width:400px; color:green">
                    <b-form-group
                        id="fieldset-20"
                        label="End Date"
                        label-for="input-date2"
                        >
                        <b-form-datepicker @input="dateChanged" value-as-date id="example-datepicker2" :max="maxDate" v-model="customDateStop" class="mb-2"></b-form-datepicker>
                    </b-form-group>
                </div>
            </b-col>
        </b-row>
        
        <!-- Total orders -->
        <b-row>
            <b-col>
                <h4>Total Orders: {{theReport.totalOrders}}</h4>
            </b-col>
        </b-row>

        <!-- Total revenue -->
        <b-row>
            <b-col>
                <h4>Total Revenue: <span style="color:green"> $ {{theReport.totalRevenue}}</span></h4>
            </b-col>
        </b-row>
        <hr>

        <!-- Monthly sales -->
        <b-row>
            <b-col style="width:400px">
                <b-card  style="width:400px" header-bg-variant="primary" header-text-variant="white"
                        header="Monthly Sales"
                    >
                    <bar-chart :chart-data="theMonthlySalesChartData" :options="monthlySalesChartOptions" ></bar-chart>
                </b-card>
                
            </b-col>

        <!-- Weekly sales -->
            <b-col style="width:400px">
                <b-card  style="width:400px" header-bg-variant="primary" header-text-variant="white"
                        header="Weekly Sales"
                    >
                    <bar-chart :chart-data="theWeeklySalesChartData" :options="weeklySalesChartOptions" ></bar-chart>
                </b-card>
            </b-col>
        </b-row>

        <!-- Buyers Table -->
        <hr>
        <b-row>
            <b-col>
                <h4>Buyers</h4>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <table class="table" style="margin-left:50px; margin-right:50px">
                    <thead class="thead-dark">
                        <tr>
                            <th>
                                Buyer
                            </th>
                            <th>
                                Orders
                            </th>
                            <th>
                                Revenue
                            </th>
                            <th>
                                Send a Message
                            </th>
                            <th>
                                Orders
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="theBuyer in theReport.buyers" :key="theBuyer.pub">
                            <td>{{theBuyer.pub}}</td>
                            <td>{{theBuyer.orders}}</td>
                            <td>$ {{theBuyer.totalCost}}</td>
                            <!-- Send a message -->
                            <td>
                                <b-button v-b-modal="'SendMsg' + theBuyer.pubid" v-b-tooltip.hover :title="'Message '+theBuyer.pub" 
                                    class='btn btn-primary action-buttons'>Send a Message
                                </b-button>
                                <b-modal size="lg" :id="'SendMsg' + theBuyer.pubid" title="Send a Message"  hide-footer :key="theBuyer.pubid + 'messagemodal'">
                                    <div class='col-12'>
                                        <sendmessage  :receiverId="theBuyer.pubid" :receiverName="theBuyer.pub" :arrayDefaultMessages="arrayDefaultMessages"/>
                                    </div>
                                </b-modal>
                            </td>
                            <!-- Show all orders -->
                            <td>
                                <b-button v-b-modal="'Showorders' + theBuyer.pubid" 
                                    class='btn btn-primary action-buttons'>Show Orders
                                </b-button>
                                <b-modal size="lg" :id="'Showorders' + theBuyer.pubid" :title="'Orders from ' + theBuyer.pub " ok-only :key="theBuyer.pubid + 'ordersmodal'">
                                    <div class='col-12'>
                                        Orders
                                        <table class="table">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th>
                                                        Date
                                                    </th>
                                                    <th>
                                                        Beverage
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="theOrder in theBuyer.ordersArray" :key="theOrder.suborderid">
                                                    <td>{{theOrder.orderDate}}</td>
                                                    <td>{{theOrder.beerName}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-modal>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>

        <!-- Beers Table -->
        <b-row>
            <b-col>
                <h4>Beverages Sold</h4>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <table class="table" style="margin-left:50px; margin-right:50px">
                    <thead class="thead-dark">
                        <tr>
                            <th>
                                Beverage
                            </th>
                            <th>
                                Orders
                            </th>
                            <th>
                                Revenue
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="theBeer in theReport.beers" :key="theBeer.beerId">
                            <td>{{theBeer.beerName}}</td>
                            <td>{{theBeer.orders}}</td>
                            <td>$ {{theBeer.totalCost}}</td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import {groupmonth} from '../Morefunctions'
import moment from 'moment'
import LineChart from './Charts/LineChart.js'
import BarChart from './Charts/BarChart.js'
import Sendmessage from '../Sendmessage'
import {timeConverterDateAndYear} from '../Myfunctions'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'newOrders', 'activeOrders', 'pastOrders','allBreweryOrders'])
    },

    components: {
        LineChart,
        BarChart,
        Sendmessage,
    },

    data() {
        return {
            arrayDefaultMessages:[],
            customOrdersArray:[],
            theReport:{},
            dailyOrders:{},
            weeklyOrders:{},
            monthlyOrders:{},
            yearlyOrders:{},
            customDateOrders:[],
            customDateStart:'',
            customDateStop:'',
            maxDate:'',
            theMonthlySalesChartData:{},
            theWeeklySalesChartData:{},

            //Monthly sales chart options
            monthlySalesChartOptions:{responsive: true, animation: false,
                plugins: {
                    datalabels: {
                        anchor :'top',
                        align :'top',
                        padding:10,
                        formatter: function(value, context) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    }
                },
                title: {
                    display: false,
                    text: 'Custom Chart Title'
                },
                legend: {
                    display: true,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                                // Include a dollar sign in the ticks
                                callback: function(value, index, values) {
                                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }
                            },
                        scaleLabel: {
                            display: false,
                            //labelString: '$',
                            
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Month'
                        }
                    }],
                } 
            },

            weeklySalesChartOptions:{responsive: true, animation: false,
                plugins: {
                    datalabels: {
                        anchor :'top',
                        align :'top',
                        padding:10,
                        formatter: function(value, context) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    }
                },
                title: {
                    display: false,
                    text: 'Custom Chart Title'
                },
                legend: {
                    display: true,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                                // Include a dollar sign in the ticks
                                callback: function(value, index, values) {
                                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }
                            },
                        scaleLabel: {
                            display: false,
                            //labelString: '$',
                            
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Week'
                        }
                    }],
                } 
            },

        }
    },

    methods:{

        //Date changed
        dateChanged(){
            //Change array to reflect new dates
            var tempArray=[]
            for (var i=0; i<this.allBreweryOrders.length; i++){
                const orderDate = this.allBreweryOrders[i].createdOn.seconds*1000
                if (orderDate>=this.customDateStart.getTime()&&orderDate<=this.customDateStop.getTime()) tempArray.push(this.allBreweryOrders[i])
            }
            this._customOrdersArray=tempArray
            this.createSalesReport()
        },
        createSalesReport(){
            //Filter for this uid's orders
            var totalOrdersCount = 0
            var revenue = 0
            var buyersList=[]
            var beersList=[]

            const ordersArray = this._customOrdersArray
            
            var revenue = 0
            //Iterate over orders
            for (var j=0; j<ordersArray.length; j++){
                revenue = revenue + parseFloat(ordersArray[j].cost)
                totalOrdersCount++

                //Add to buyers
                const existingBuyerindex = buyersList.findIndex(item => item.pubid === ordersArray[j].pubid);
                //Check if already in list
                //If not, add new one
                if(existingBuyerindex<0){
                    var orders=[]
                    var thisOrder = ordersArray[j]
                    //Set order date
                    thisOrder.orderDate = timeConverterDateAndYear(thisOrder.createdOn.seconds)
                    orders.push(thisOrder)
                    var buyer={pub:ordersArray[j].pub, pubid:ordersArray[j].pubid, orders:1, totalCost: ordersArray[j].totalCost, ordersArray: orders}
                    buyersList.push(buyer)
                } 
                //If already exists, increment count
                else{
                    var theBuyerObj = buyersList[existingBuyerindex]
                    theBuyerObj.orders = theBuyerObj.orders + 1
                    theBuyerObj.totalCost = theBuyerObj.totalCost + ordersArray[j].totalCost
                    var buyerOrdersArray = theBuyerObj.ordersArray
                    var thisOrder = ordersArray[j]
                    //Set order date
                    thisOrder.orderDate = timeConverterDateAndYear(thisOrder.createdOn.seconds)

                    buyerOrdersArray.push(thisOrder)
                    theBuyerObj.ordersArray = buyerOrdersArray
                    buyersList.splice(existingBuyerindex, 1, theBuyerObj)
                }
                

                //Add to beers
                const existingBeerindex = beersList.findIndex(item => item.beerId === ordersArray[j].beerId);
                if(existingBeerindex<0){
                    var beer={beerName:ordersArray[j].beerName, beerId:ordersArray[j].beerId, orders:1, totalCost: ordersArray[j].totalCost}
                    beersList.push(beer)
                } 
                //Already in array. Update number of orders
                else{
                    var theBeerOBJ = beersList[existingBeerindex]
                    theBeerOBJ.orders = theBeerOBJ.orders + 1
                    theBeerOBJ.totalCost = theBeerOBJ.totalCost + ordersArray[j].totalCost
                    beersList.splice(existingBeerindex, 1, theBeerOBJ)
                }
            }

            //Sort the buyers and beers list by revenue
            function compare(a, b) {
                const costA = a.totalCost;
                const costB = b.totalCost;

                let comparison = 0;
                if (costA <costB) {
                        comparison = 1;
                } else if (costA>costB) {
                        comparison = -1;
                }
                    return comparison;
            }
            buyersList.sort(compare);
            beersList.sort(compare);

            this.theReport = {
                                totalOrders:totalOrdersCount, 
                                totalRevenue:parseFloat(revenue.toFixed(2)), 
                                buyers:buyersList,
                                beers:beersList,
                                }
            //console.log('grouped by month',ordersArray.map(groupmonth));
            // Group by time period - By 'day' | 'week' | 'month' | 'year'
            // ------------------------------------------------------------
            var groupByTimePeriod = function (obj, timestamp, period) {
            var objPeriod = {};
            var oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
            for (var i = 0; i < obj.length; i++) {
                var d = new Date(obj[i].createdOn.seconds * 1000);
                if (period == 'day') {
                d = Math.floor(d.getTime() / oneDay);
                } else if (period == 'week') {
                d = Math.floor(d.getTime() / (oneDay * 7));
                } else if (period == 'month') {
                d = (d.getFullYear() - 1970) * 12 + d.getMonth();
                } else if (period == 'year') {
                d = d.getFullYear();
                } else {
                console.log('groupByTimePeriod: You have to set a period! day | week | month | year');
                }
                // define object key
                objPeriod[d] = objPeriod[d] || [];
                objPeriod[d].push(obj[i]);
            }
            return objPeriod;
            };

            this.dailyOrders = groupByTimePeriod(this._customOrdersArray, 'date', 'day');
            this.weeklyOrders = groupByTimePeriod(this._customOrdersArray, 'date', 'week');
            this.monthlyOrders = groupByTimePeriod(this._customOrdersArray, 'date', 'month');
            this.yearlyOrders = groupByTimePeriod(this._customOrdersArray, 'date', 'year');

            console.log(this.dailyOrders);
            console.log(this.weeklyOrders);
            console.log(this.monthlyOrders);
            console.log(this.yearlyOrders);
            this.createMonthlySalesChart()
            this.createWeeklySalesChart()

        },

        //Create monthly sales data
        createMonthlySalesChart(){
            
            var stopMonth = (this.customDateStop.getFullYear() - 1970) * 12 + this.customDateStop.getMonth();
            var startMonth = (this.customDateStart.getFullYear() - 1970) * 12 + this.customDateStart.getMonth();

                var theChartData={}
                var numberofsalesarray = []
                var labels=[]
                var datasets=[]

                //Get the keys for months array
                var months = Object.keys(this.monthlyOrders);

                //Find the max month
                var maxMonth = Math.max(...months);
                //Start from 12 months ago
                var minMonth = maxMonth-12
                if (minMonth<0) minMonth=0
                
                //Iterate from minmonth to maxmonth
                for (var i=startMonth+1; i<=stopMonth; i++){
                    //Check if month in months array
                    if (i in this.monthlyOrders){
                        numberofsalesarray.push(this.monthlyOrders[i].length)
                    }
                    //Sales data for this month not found
                    else{
                        numberofsalesarray.push(0)
                    }
                    //Add the month label
                    var monthInt = i%12
                    var monthString=""
                    switch(monthInt) {
                        case 0:
                            monthString='Jan'
                            break;
                        case 1:
                            monthString='Feb'
                            break;
                        case 2:
                            monthString='Mar'
                            break;
                        case 3:
                            monthString='Apr'
                            break;
                        case 4:
                            monthString='May'
                            break;
                        case 5:
                            monthString='Jun'
                            break;
                        case 6:
                            monthString='Jul'
                            break;
                        case 7:
                            monthString='Aug'
                            break;
                        case 8:
                            monthString='Sep'
                            break;
                        case 9:
                            monthString='Oct'
                            break;
                        case 10:
                            monthString='Nov'
                            break;
                        case 11:
                            monthString='Dec'
                            break;
                        default:
                            monthString=""
                        }
                    labels.push(monthString)
                }

                //Setup dataset
                datasets.push({
                    label: 'Monthly Number of Orders',
                    labels:labels,
                    borderColor: '#249EBF',
                    pointBackgroundColor: 'white',
                    borderWidth: 2,
                    pointBorderColor: '#249EBF',
                    backgroundColor: 'transparent',
                    data:numberofsalesarray,
                    })
                theChartData.labels=labels
                theChartData.datasets=datasets
                this.theMonthlySalesChartData = theChartData

        },
        //Create weekly sales data
        createWeeklySalesChart(){
            var oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
            var startWeek = Math.floor(this.customDateStart.getTime() / (oneDay * 7));
            var stopWeek = Math.floor(this.customDateStop.getTime() / (oneDay * 7));

                var theChartData={}
                var numberofsalesarray = []
                var labels=[]
                var datasets=[]

                //Get the keys for months array
                var weeks = Object.keys(this.weeklyOrders);

                //Find the max month
                var maxWeek = Math.max(...weeks);
                //Start from 12 months ago
                var minWeek = maxWeek-52
                if (minWeek<0) minWeek=0
                var weekCount=0
                
                //Iterate from minmonth to maxmonth
                for (var i=startWeek+1; i<=stopWeek; i++){
                    weekCount++
                    //Check if month in months array
                    if (i in this.weeklyOrders){
                        numberofsalesarray.push(this.weeklyOrders[i].length)
                    }
                    //Sales data for this month not found
                    else{
                        numberofsalesarray.push(0)
                    }
                    //Add the month label
                    labels.push(weekCount)
                }

                //Setup dataset
                datasets.push({
                    label: 'Weekly Number of Orders',
                    labels:labels,
                    borderColor: '#249EBF',
                    pointBackgroundColor: 'white',
                    borderWidth: 2,
                    pointBorderColor: '#249EBF',
                    backgroundColor: 'transparent',
                    data:numberofsalesarray,
                    })
                theChartData.labels=labels
                theChartData.datasets=datasets
                this.theWeeklySalesChartData = theChartData

        },
    },

    mounted(){
        //Set custom arrray
        this._customOrdersArray=this.allBreweryOrders
        //Set custom start and end dates

        const maxDate = new Date()
        this.maxDate=maxDate
        
        var minDate = new Date()
        minDate.setMonth(minDate.getMonth() - 12)
        this.customDateStop=maxDate
        this.customDateStart=minDate
        
        this.createSalesReport()
    },
}
</script>

